module.exports = __webpack_public_path__ + "static/media/twitter.b64db85c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/twitter.svg
// module id = 358
// module chunks = 25